"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ApiToken;
    }
});
const _nanoid = require("nanoid");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let ApiToken = class ApiToken {
    static async insert(apiToken, ncMeta = _Noco.default.ncMeta) {
        var _apiToken_fk_sso_client_id;
        const token = (0, _nanoid.nanoid)(40);
        await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
            description: apiToken.description,
            token,
            fk_user_id: apiToken.fk_user_id,
            fk_sso_client_id: (_apiToken_fk_sso_client_id = apiToken.fk_sso_client_id) != null ? _apiToken_fk_sso_client_id : null
        }, true);
        return this.getByToken(token).then(async (apiToken)=>{
            await _NocoCache.default.appendToList('root', _globals.CacheScope.API_TOKEN, [], `${_globals.CacheScope.API_TOKEN}:${token}`);
            return apiToken;
        });
    }
    static async list(userId, ncMeta = _Noco.default.ncMeta) {
        // let tokens = await NocoCache.getList(CacheScope.API_TOKEN, []);
        // if (!tokens.length) {
        const tokens = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
            condition: {
                fk_user_id: userId
            }
        });
        // await NocoCache.setList(CacheScope.API_TOKEN, [], tokens);
        // }
        return tokens == null ? void 0 : tokens.map((t)=>this.castType(t));
    }
    static async listForNonSsoUser(userId, ncMeta = _Noco.default.ncMeta) {
        const tokens = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
            condition: {
                fk_user_id: userId,
                fk_sso_client_id: null
            }
        });
        return tokens == null ? void 0 : tokens.map((t)=>this.castType(t));
    }
    static async delete(tokenId, ncMeta = _Noco.default.ncMeta) {
        const tokenData = await this.get(tokenId, ncMeta);
        await _NocoCache.default.deepDel('root', `${_globals.CacheScope.API_TOKEN}:${tokenData.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        return await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, tokenId);
    }
    static async getByToken(token, ncMeta = _Noco.default.ncMeta) {
        let data = token && await _NocoCache.default.get('root', `${_globals.CacheScope.API_TOKEN}:${token}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!data) {
            data = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
                token
            });
            await _NocoCache.default.set('root', `${_globals.CacheScope.API_TOKEN}:${token}`, data);
        }
        return data && this.castType(data);
    }
    static async count({ fk_user_id, includeUnmappedToken = false, ssoClientId } = {}, ncMeta = _Noco.default.ncMeta) {
        var _ref;
        var _this;
        const qb = ncMeta.knex(_globals.MetaTable.API_TOKENS);
        if (fk_user_id) {
            qb.where(`${_globals.MetaTable.API_TOKENS}.fk_user_id`, fk_user_id);
        }
        // SSO filtering logic - if no ssoClientId, user is non-SSO and should only see non-SSO tokens
        if (!ssoClientId) {
            qb.whereNull(`${_globals.MetaTable.API_TOKENS}.fk_sso_client_id`);
        }
        // If ssoClientId exists, user logged via SSO and sees all tokens (no additional filtering)
        if (includeUnmappedToken) {
            qb.orWhereNull(`${_globals.MetaTable.API_TOKENS}.fk_user_id`);
        }
        return (_ref = (_this = await qb.count('id', {
            as: 'count'
        }).first()) == null ? void 0 : _this.count) != null ? _ref : 0;
    }
    static async listWithCreatedBy({ limit = 10, offset = 0, fk_user_id, includeUnmappedToken = false, ssoClientId }, ncMeta = _Noco.default.ncMeta) {
        const queryBuilder = ncMeta.knex(_globals.MetaTable.API_TOKENS).offset(offset).limit(limit).select(`${_globals.MetaTable.API_TOKENS}.id`, `${_globals.MetaTable.API_TOKENS}.token`, `${_globals.MetaTable.API_TOKENS}.description`, `${_globals.MetaTable.API_TOKENS}.fk_user_id`, `${_globals.MetaTable.API_TOKENS}.fk_sso_client_id`, `${_globals.MetaTable.API_TOKENS}.base_id`, `${_globals.MetaTable.API_TOKENS}.created_at`, `${_globals.MetaTable.API_TOKENS}.updated_at`).select(ncMeta.knex(_globals.MetaTable.USERS).select('email').whereRaw(`${_globals.MetaTable.USERS}.id = ${_globals.MetaTable.API_TOKENS}.fk_user_id`).as('created_by'));
        if (fk_user_id) {
            queryBuilder.where(`${_globals.MetaTable.API_TOKENS}.fk_user_id`, fk_user_id);
        }
        // SSO filtering logic - if no ssoClientId, user is non-SSO and should only see non-SSO tokens
        if (!ssoClientId) {
            queryBuilder.whereNull(`${_globals.MetaTable.API_TOKENS}.fk_sso_client_id`);
        }
        // If ssoClientId exists, user logged via SSO and sees all tokens (no additional filtering)
        if (includeUnmappedToken) {
            queryBuilder.orWhereNull(`${_globals.MetaTable.API_TOKENS}.fk_user_id`);
        }
        return queryBuilder;
    }
    static async get(tokenId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, tokenId);
    }
    static async clearSsoAssociation(ssoClientId, ncMeta = _Noco.default.ncMeta) {
        if (!ssoClientId) {
            _catchError.NcError.badRequest('SSO client ID is required');
        }
        const tokens = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
            condition: {
                fk_sso_client_id: ssoClientId
            }
        });
        for (const token of tokens){
            // Update database to remove SSO association
            await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.API_TOKENS, {
                fk_sso_client_id: null
            }, token.id);
            // Clear cache
            await _NocoCache.default.deepDel('root', `${_globals.CacheScope.API_TOKEN}:${token.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
            await _NocoCache.default.del('root', `${_globals.CacheScope.API_TOKEN}:${token.token}`);
        }
        return (tokens == null ? void 0 : tokens.length) || 0;
    }
    async getExtraForUserPayload(_ncMeta = _Noco.default.ncMeta) {
        return; // Placeholder for future implementation
    }
    static castType(apiToken) {
        return apiToken && new ApiToken(apiToken);
    }
    constructor(audit){
        Object.assign(this, audit);
    }
};
